const SvgBusinessAutomation2 = (props) => (
  <>
    <defs />
    <path
      d="M73.29 192h117.42M192 192.31l85.5-85.81M192 376v-56"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <circle cx={192} cy={192} r={8} fill="#0062ff" strokeWidth={0} />
    <circle cx={192} cy={192} r={24} stroke="#001d6c" fill="none" strokeMiterlimit={10} />
    <path
      d="M287.94 107.31a7.981 7.981 0 0 1-5.98 2.69c-4.42 0-8.01-3.58-8.01-8 0-2.38 1.04-4.5 2.69-5.97C254.05 76.1 224.38 64 191.87 64 123.79 64 68.13 117.04 64 184.01c4.3.14 7.75 3.66 7.75 7.99s-3.45 7.85-7.75 7.99C68.13 266.96 123.8 320 191.87 320S320 262.69 320 192c0-32.48-12.11-62.12-32.06-84.69Z"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <path
      d="M64.26 184.01c-.09 0-.17-.01-.26-.01-4.42 0-8 3.58-8 8s3.58 8 8 8c.09 0 .17-.01.26-.01 4.3-.14 7.74-3.65 7.74-7.99s-3.45-7.85-7.74-7.99ZM282 94c-2.04 0-3.9.77-5.31 2.03A7.96 7.96 0 0 0 274 102c0 4.42 3.58 8 8 8 2.38 0 4.5-1.04 5.97-2.69A7.945 7.945 0 0 0 290 102c0-4.42-3.58-8-8-8Z"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <path
      d="M384 192.09C384 86 298.04 0 192 0S0 86 0 192.09 81.68 379.81 184.01 384c.1-4.34 3.63-7.83 7.99-7.83s7.9 3.49 7.99 7.83C302.32 379.81 384 295.5 384 192.09Z"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <path
      d="M199.99 383.82a7.991 7.991 0 0 0-15.98 0v.18c0 4.42 3.58 8 8 8s8-3.58 8-8v-.18Z"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
  </>
);

export default SvgBusinessAutomation2;
